import React from 'react';

const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US'));

// rows: DB-shaped expense items ({ item, link, amount, position }).
export function ExpenseItemsTable({ rows }) {
  if (!rows || rows.length === 0) return null;
  const ordered = [...rows].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  const total = ordered.reduce((s, r) => s + (Number.isFinite(Number(r.amount)) ? Number(r.amount) : 0), 0);
  return (
    <section className="expense-items" aria-label="Expenses">
      <h4>Expenses</h4>
      <table className="kpi-bundle-table expense-items-table">
        <thead><tr><th>Item</th><th>Link</th><th>Amount, USD</th></tr></thead>
        <tbody>
          {ordered.map((r, i) => (
            <tr key={r.id || i}>
              <td>{r.item}</td>
              <td>{r.link ? <a href={r.link} target="_blank" rel="noreferrer">link</a> : '—'}</td>
              <td>{num(r.amount)}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={2}><strong>Total</strong></td>
            <td><strong data-testid="expense-total-readonly">{num(total)}</strong></td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}
